
/**Doku dazu welche Optionen es bei den Icons gibt https://confluence.shgruppe.de/confluence/display/SHG/SVG+Icons **/
import {defineComponent} from 'vue';

export default defineComponent({
    name: "IconBase",
    props: {
        type: {
            type: String,
            default: 'icon',
            validator: function (value: string): boolean {
                // The value must match one of these strings
                return ['icon', 'picto'].indexOf(value) !== -1
            }
        },
        name: {
            type: String,
            required: true,
            default: 'dropdown'
        },
        position: {
            type: String,
            default: 'left',
            validator: function (value: string): boolean {
                // The value must match one of these strings
                return ['left', 'right'].indexOf(value) !== -1
            }
        },
        additionalCssClasses: {
            type: String,
            default: function (props: any) {
                return props.type + '--default';
            }
        }
    },
    computed: {
        svgClass(): string {
            return 'svg-' + this.type + ' ' + this.$props.additionalCssClasses + this.iconPositionCssClass;
        },
        svgHref(): string {
            return '#' + this.$props.type + '--' + this.$props.name;
        },
        iconPositionCssClass(): string {
            return this.$props.position === 'right' ? ' icon--right' : '';
        }
    }
});
